import React from 'react'
import {FaLinkedin} from 'react-icons/fa'

function Footer (){


return(
    <div className='footer'>
        <a href="https://www.linkedin.com/in/joespizzandre/" target="blank" rel="noreferrer">  <FaLinkedin fill='white'/>   </a>
        <h3 className='footwords'>Joe Spizzandre 2023</h3>
      
    </div>
)

}

export default Footer